const customHits = instantsearch.connectors.connectHits(renderProducts);
const apiUrl = 'https://bss-beta.myshopify.com/api/2022-07/graphql';
const headers = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Shopify-Storefront-Access-Token': '573bafa209a36f004b6de8effdbc42ee'
});
let graphqlProductCache = [];

function renderProducts(renderOptions, isFirstRender) {
  const {
    hits,
    widgetParams,
    instantSearchInstance,
    promoTiles,
    infiniteScroll
  } = renderOptions;
  // Check if hits are being filtered by color to know
  // whether to render hit.product_image or hit.image
  const colorFilterApplied =
    instantSearchInstance?.renderState?.shopify_products?.currentRefinements?.items?.some(
      item => item.attribute === 'options.color'
    );
  // Track number of promo tiles inserted
  let count = 1;

  widgetParams.container.innerHTML = `
      <div class="instantsearch__row instantsearch__row--wrap">
        ${hits
          .map((hit, idx) => {
            // Check if we have promo tiles for this collection
            // and render every 7th slot until none left
            const isDivisibleBySeven = (idx + count) % 7 === 0;
            const promoTileIndex = (idx + count) / 7 - 1;
            if (
              promoTiles &&
              isDivisibleBySeven &&
              promoTiles[promoTileIndex]
            ) {
              const items = [
                renderPromoTile(promoTiles[promoTileIndex]),
                renderProduct(hit, { colorFilterApplied })
              ].join('');
              count++;
              return items;
            } else {
              return renderProduct(hit, { colorFilterApplied });
            }
          })
          .join('')}
      </div>
    `;
  if (infiniteScroll) {
    if (isFirstRender) {
      // Load more button
      const button = document.createElement('button');
      button.classList.add('load-more-button');
      button.textContent = 'View more';
      button.addEventListener('click', () => {
        renderOptions.showMore();
      });
      document.querySelector('#search-pagination-load-more').append(button);
    }

    // Calculate stats and progress
    const { isLastPage, results } = renderOptions;
    if (results) {
      // const start = results.page === 0 ? 1 : results.hitsPerPage * results.page + 1
      const end =
        results.nbHits <= results.hitsPerPage * (results.page + 1)
          ? results.nbHits
          : results.hitsPerPage * (results.page + 1);
      const stats = `Viewing ${end} of ${results.nbHits} products`;
      const progress = isLastPage ? 100 : (end / results.nbHits) * 100;

      if (isLastPage) {
        document.querySelector('.load-more-button').disabled = true;
        document.querySelector(
          '#search-pagination-progress-bar'
        ).style.width = `100%`;
      } else {
        document.querySelector('.load-more-button').disabled = false;
        document.querySelector(
          '#search-pagination-progress-bar'
        ).style.width = `${progress}%`;
      }

      document.querySelector('#search-pagination-stats').textContent = stats;
    }
  }
}

function renderSortBy(renderOptions, isFirstRender) {
  const { options, currentRefinement, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const select = document.createElement('select');

    select.addEventListener('change', event => {
      refine(event.target.value);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector('select');
  // add for styling
  select.classList.add('ais-SortBy-select');
  // add for accessibility <label for="sortSelect">
  select.setAttribute('id', 'sortSelect');
  select.innerHTML = `
    ${options
      .map(
        option => `
          <option class="ais-SortBy-option"
            value="${option.value}"
            ${option.value === currentRefinement ? 'selected' : ''}
          aria-label="Sort by ${option.label}">
            ${option.label}
          </option>
        `
      )
      .join('')}
  `;
}

async function getProductsByIds(ids) {
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      query: `
      {
        nodes(ids: ${JSON.stringify(ids)}) {
          ... on Product {
            id
            title
            tags
            vendor
            collections(first: 20) {
              nodes {
                title
              }
            }
            priceRange {
              maxVariantPrice {
                amount
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
              }
            }
            images(first: 20) {
              nodes {
                url(transform: {preferredContentType: WEBP, maxHeight: 450, maxWidth: 450})
              }
            }
            options(first: 5) {
              name
              values
            }
            variants(first: 100) {
              nodes {
                title
                id
                availableForSale
                selectedOptions {
                  name
                  value
                }
                image {
                  url(transform: {preferredContentType: WEBP, maxHeight: 450, maxWidth: 450})
                }
              }
            }
          }
        }
      }
    `
    })
  });
  try {
    return await response.json();
  } catch (e) {
    console.error(e);
  }
}

function renderPromoTile(promoTile) {
  return `
    <div class="instantsearch__col instantsearch__col--product">
    ${
      promoTile.promo_tile_link
        ? `
        <a class='promo-tile' href='${promoTile.promo_tile_link}' aria-label="Link to ${promoTile.promo_tile_alt_text}">
          <img
            class='promo-tile__img promo-tile__img--lg'
            src='${promoTile.promo_tile_img}&width=375'
            alt='${promoTile.promo_tile_alt_text}'
          />
          <img
            class='promo-tile__img promo-tile__img--sm'
            src='${promoTile.promo_tile_img_mobile}&width=275'
            alt='${promoTile.promo_tile_alt_text}'
          />
        </a>
      `
        : `
        <div class='promo-tile'>
          <img
            class='promo-tile__img promo-tile__img--lg'
            src='${promoTile.promo_tile_img}&width=375'
            alt='${promoTile.promo_tile_alt_text}'
          />
          <img
            class='promo-tile__img promo-tile__img--sm'
            src='${promoTile.promo_tile_img_mobile}&width=275'
            alt='${promoTile.promo_tile_alt_text}'
          />
        </div>
      `
    }
    </div>
  `;
}

function calculateSalePrice(price) {
  const percentageOff = window.saleDiscountPercentage;
  const discount = 1 - percentageOff / 100;
  return price * discount;
}

function renderProduct(hit, options) {
  let queryID = localStorage.getItem('queryID');
  const color = hit.options?.color ?? null;
  const activeCurrencyCode = Shopify.currency.active;
  // turn rate string to an int
  const activeCurrencyRate = Number(Shopify.currency.rate);
  let currentCompareAtPrice = hit.compare_at_price;
  let currentPrice = hit.price;

  // Check if sale is on and product is not already discounted
  if (window.isSaleEnabled) {
    // Check if product is excluded from sale
    if (hit.tags.includes(window.saleEnabledTag)) {
      currentCompareAtPrice = currentCompareAtPrice || currentPrice;
    }
  }

  if (activeCurrencyCode === 'USD') {
    currentCompareAtPrice = currentCompareAtPrice
      ? `$${Math.round(Math.ceil(currentCompareAtPrice))
          .toFixed(2)
          .replace('.00', '')}`
      : '';
    currentPrice =
      window.isSaleEnabled && hit.tags.includes(window.saleEnabledTag)
        ? `$${calculateSalePrice(currentPrice).toFixed(2)}`
        : `$${currentPrice.toFixed(2)}`;
  } else if (activeCurrencyCode === 'CAD' || activeCurrencyCode === 'AUD') {
    currentCompareAtPrice = currentCompareAtPrice
      ? `$${Math.round(Math.ceil(currentCompareAtPrice * activeCurrencyRate))
          .toFixed(2)
          .replace('.00', '')}`
      : '';
    currentPrice =
      window.isSaleEnabled && hit.tags.includes(window.saleEnabledTag)
        ? `$${calculateSalePrice(
            Math.round(Math.ceil(currentPrice * activeCurrencyRate))
          ).toFixed(2)}`
        : `$${Math.round(Math.ceil(currentPrice * activeCurrencyRate)).toFixed(
            2
          )}`;
  } else if (activeCurrencyCode === 'GBP') {
    currentCompareAtPrice = currentCompareAtPrice
      ? `£${Math.round(Math.ceil(currentCompareAtPrice * activeCurrencyRate))
          .toFixed(2)
          .replace('.00', '')}`
      : '';
    currentPrice =
      window.isSaleEnabled && hit.tags.includes(window.saleEnabledTag)
        ? `£${calculateSalePrice(
            Math.round(Math.ceil(currentPrice * activeCurrencyRate))
          ).toFixed(2)}`
        : `£${Math.round(Math.ceil(currentPrice * activeCurrencyRate)).toFixed(
            2
          )}`;
  }

  let link = `/products/${hit.handle}?variant=${hit.objectID}`;
  if (queryID) {
    link = `${link}&queryID=${queryID}`;
  }
  let imgSrc =
    color || options.colorFilterApplied ? hit.image : hit.product_image;
  if (hit.tags.includes('hide_quick_colors')) {
    imgSrc = hit.product_image;
  }
  // responsive image sizes for product cards
  let imgWidthParam = '&width=300';

  // check for retina screens
  if (window.devicePixelRatio > 1) {
    imgWidthParam = window.innerWidth > 768 ? '&width=500' : '&width=350';
  } else if (window.innerWidth > 768) {
    imgWidthParam = '&width=450';
  }

  return `
      <div class="instantsearch__col instantsearch__col--product">
        <product-card color="${color}">
          <div class="product-card product-card--${hit.id}" data-product-id="${hit.id}" data-variant-id="${hit.objectID}" data-color="${color}">
            <div class="product-card__tag"></div>
            <a href='${link}' class="product-card__image" aria-label="Link to ${hit.title}">
              <img alt="${hit.title}" loading="lazy" src="${imgSrc}${imgWidthParam}" />
              <div class="product-card__options"></div>
              <div class="product-card__cta"></div>
            </a>
            <a href='${link}' class="product-card__details" aria-label="Link to ${hit.title}">
              <h3 class="product-card__title">${hit.title}</h3>
              <p class="product-card__price">
                <span class="product-card__amount product-card__amount--compare">${currentCompareAtPrice}</span>
                <span class="product-card__amount js--product-price">${currentPrice}</span>
              </p>
            </a>
            <div class="product-card__colors"></div>
          </div>
        </product-card>
      </div>
    `;
}
function enrichProducts(data) {
  // For infinite scroll we cache products we've already fetched
  // so we don't have to query for the entire product list again
  graphqlProductCache.push(...data.nodes);

  // Grab all product cards in grid
  const hits = document.querySelectorAll('.product-card');
  let tags = null;
  try {
    tags = JSON.parse(
      document.getElementById('promo-tag-manager-json').innerHTML
    ).promoTags;
  } catch (e) {
    console.warn("Can't set promoTags.");
  }

  // Associate product-card element with Shopify product data and
  // set gql-product attribute to initialize product-card web component extras
  hits.forEach((hit, idx) => {
    const productCard = hit.closest('product-card');
    if (productCard) {
      const product = graphqlProductCache?.find(
        node => `gid://shopify/Product/${hit.dataset.productId}` === node?.id
      );
      productCard.setAttribute('gql-product', JSON.stringify({ ...product }));
      addPromoTags({ productData: product, element: hit, promoTags: tags });
    }

    // Add click listener
    hit.querySelectorAll('a').forEach(anchor =>
      anchor.addEventListener('click', () =>
        trackProductClick({
          objectID: hit.dataset.variantId,
          position: idx + 1
        })
      )
    );
  });
}
function createDataAttribtues(refinement) {
  return Object.keys(refinement)
    .map(key => `data-${key}="${refinement[key]}"`)
    .join(' ');
}
function renderRefinementItem(item) {
  return `
      <li class="ais-CurrentRefinements-item">
      ${item.refinements
        .map(
          refinement =>
            `
                <span class="ais-CurrentRefinements-category">
                  <span class="ais-CurrentRefinements-categoryLabel">
                    ${refinement.label}
                  </span>
                  <button aria-label="Remove refinement" class="ais-CurrentRefinements-delete" ${createDataAttribtues(
                    refinement
                  )} >x</button>
                </span>
                `
        )
        .join('')}
      </li>
    `;
}
function renderCurrentRefinements(renderOptions, isFirstRender) {
  const { items, refine, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = `
      <div class="ais-CurrentRefinements ais-CurrentRefinements--mobile ${
        !items.length ? 'empty' : ''
      }">
        <ul class="ais-CurrentRefinements-list">
          <li class="ais-CurrentRefinements-title">Filters:</li>
          ${items.map(renderRefinementItem).join('')}
        </ul>
      </div>
    `;
  [...widgetParams.container.querySelectorAll('button')].forEach(element => {
    element.addEventListener('click', event => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key]
        }),
        {}
      );
      refine(item);
    });
  });
}

function addPromoTags({ productData, element, promoTags }) {
  let tagToRender = null;
  promoTags.filter(promoTag => {
    // Check if product tags are in promo tags
    const match = productData?.tags?.find(tag => tag === promoTag.relatedTag);
    // Find highest priority match
    if (match && !promoTag.supersedeTags.includes(match)) {
      tagToRender = promoTag;
    }
  });
  if (tagToRender) {
    element.querySelector('.product-card__tag').innerHTML = `
      <div
        class="promo-tag"
        style="color: ${tagToRender.textColor}; background-color: ${tagToRender.backgroundColor};"
      >${tagToRender.label}</div>
    `;
  }
}
function showMoreText(data) {
  return data.isShowingMore ? '- Less' : '+ More';
}
function colorItemsTemplate(item) {
  const { url, label, value } = item;

  return `
    <a role="button" aria-label="filter by ${label}" href="${url}" class="swatch-filter ${slugify(
    value
  )}">
      <div class="swatch-color-square__container">
        <span class="swatch-color-square">
          <span class="checkbox"></span>
        </span>
      </div>
      <span>${label}</span>
    </a>
    `;
}
function sizeItemsTemplate(item) {
  const { url, label, value } = item;

  return `
      <a role="button" aria-label="filter by size" href="${url}" class="size-filter ${slugify(
    value
  )} aria-label="Filter by size ${label}">
        <span>${label}</span>
      </a>
    `;
}

function slugify(text) {
  return text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[/]+/g, '-')
    .replace(/[-]+/g, '-')
    .replace(/[^\w-]+/g, '');
}

const sizeRefinementOrder = [
  'XS',
  'S',
  'M',
  'M/L',
  'L',
  'XL',
  '2XL',
  '3XL',
  '4XL',
  '5XL',
  'One Size',
  '3-6m',
  '6-12m',
  '12-18m',
  '18-24m',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13″'
];

function trackAlgoliaEvent(event) {
  const { insightsMethod, payload } = event;

  if (payload.index === 'shopify_products_query_suggestions') return;
  if (insightsMethod === 'viewedObjectIDs') {
    trackProductListView(event);
  }
  if (insightsMethod === 'clickedFilters') {
    trackFilterClick(event);
  }
}

function trackProductListView(params) {
  const { payload } = params;
  const properties = {
    eventType: 'view',
    index: payload.index,
    objectIDs: payload.objectIDs,
    queryID: payload.queryID
  };
  analytics.track('Product List Viewed', properties);
}

function trackFilterClick(params) {
  const { payload } = params;
  const properties = {
    eventType: 'click',
    index: payload.index,
    filters: payload.filters,
    queryID: payload.queryID
  };
  analytics.track('Product List Filtered', properties);
}

function trackProductView(params) {
  const { objectID } = params;
  analytics.track('Product Viewed', {
    eventType: 'view',
    index: 'shopify_products',
    objectID: `${objectID}`
  });
}

function trackProductClick(params) {
  const { objectID, position } = params;
  let queryID = localStorage.getItem('queryID');

  const properties = {
    eventType: 'click',
    objectID,
    queryID,
    position,
    index: 'shopify_products'
  };
  analytics.track('Product Clicked', properties);
}

function trackProductAdd(params) {
  const { objectID, queryID } = params;

  if (queryID) {
    analytics.track('Product Added', {
      queryID: queryID,
      eventType: 'conversion',
      index: 'shopify_products',
      objectID: `${objectID}`
    });
  }
}
